<div class="company-cards">
  <!-- <p class="sectitle">Trending activities in Companies</p> -->
  <div class="list-wrapper d-flex flex-wrap" ngClass="{{device}}">
    <p-carousel class="carousel--wrapper" *ngIf="companyList?.length > 0" [value]="companyList" [numVisible]="2"
      [numScroll]="2" [circular]="false" [autoplayInterval]="0">
      <ng-template pTemplate="item" let-company>
        <app-company-card [company]="company" class="card-company">
          <!-- style="margin-bottom: -2rem !important;" class="pb-2 card-company" -->
        </app-company-card>
      </ng-template>
    </p-carousel>
  </div>
</div>
